import { has, isNumber, isString, isArray, isBoolean, toString, isSafeInteger, toSafeInteger, get, castArray, isNull, isUndefined, isNaN, toNumber, } from 'lodash-es';
import { isJSON, isDate } from './conditionals';
import clone from 'clone';
export function parseDataSet(dataset) {
    Object.keys(dataset).forEach((key) => {
        const value = dataset[key];
        switch (true) {
            case 'true' === value:
                dataset[key] = true;
                break;
            case 'false' === value:
                dataset[key] = false;
                break;
            case isJSON(value):
                const parsedData = JSON.parse(value);
                dataset[key] = parsedData ? parseDataSet(parsedData) : null;
                break;
            case isDate(value):
                dataset[key] = sanitizeDate(value);
                break;
        }
    });
    return dataset;
}
export const sanitizeFloat = (val, decimals = null) => {
    let result = 0;
    if (isNull(val) || isUndefined(val) || isNaN(val) || false === val) {
        result = 0;
    }
    else if (true === val) {
        result = 1;
    }
    else if (isString(val) || isNumber(val)) {
        if (null === decimals) {
            result = parseFloat(`${val}`);
        }
        else {
            result = parseFloat(parseFloat(`${val}`).toFixed(decimals));
        }
    }
    else {
        result = parseFloat(toNumber(val).toFixed(decimals));
    }
    if (!isNumber(result) || !isFinite(result) || isNaN(result)) {
        return 0;
    }
    return result;
};
export const sanitizeInt = (val) => {
    if (isSafeInteger(val)) {
        return val;
    }
    return toSafeInteger(val);
};
export const sanitizeId = (val) => {
    let result = null;
    if (isNumber(val) || isString(val)) {
        result = sanitizeInt(val);
    }
    else if (get(val, 'id', null)) {
        result = sanitizeInt(get(val, 'id'));
    }
    return result ? result : null;
};
export const sanitizeIds = (val) => {
    return sanitizeArray(val).map(sanitizeId).filter(sanitizeBoolean);
};
export const sanitizeDate = (input) => {
    if (!input) {
        return null;
    }
    let date = null;
    if (has(input, 'date')) {
        date = input.date;
    }
    else {
        date = input;
    }
    if (date instanceof Date) {
        return date;
    }
    if (isString(date)) {
        if (!/^\d{4}-\d{2}-\d{2}/.test(date)) {
            return null;
        }
        let timestamp = Date.parse(date);
        if (isNaN(timestamp)) {
            return null;
        }
        if (timestamp) {
            return new Date(timestamp);
        }
    }
    return null;
};
export const sanitizeBoolean = (val) => {
    if (isBoolean(val)) {
        return val;
    }
    if (['false', 0, '0', 'no', 'nei', null, undefined, 'disabled'].includes(val)) {
        return false;
    }
    if (['true', 1, '1', 'yes', 'ja'].includes(val)) {
        return true;
    }
    return Boolean(val);
};
export const sanitizeString = (val) => {
    if (isString(val)) {
        return val;
    }
    if (isBoolean(val)) {
        return val ? 'true' : 'false';
    }
    return toString(val);
};
export const sanitizeArray = (val) => {
    if (isArray(val)) {
        return val;
    }
    if (isNull(val) || isUndefined(val) || isNaN(val)) {
        return [];
    }
    return castArray(val);
};
export const sanitizePercentage = (value) => {
    return sanitizeFloat(value, 4);
};
export const sanitizeKr = (val) => {
    return sanitizeFloat(val, 2);
};
export const sanitizeSerializable = (rawdata) => {
    const data = clone(rawdata);
    if (data instanceof Date) {
        return data.toISOString();
    }
    else if (data && 'object' === typeof data) {
        Object.keys(Object.assign({}, data)).forEach((key) => {
            data[key] = sanitizeSerializable(data[key]);
        });
    }
    return data;
};
